import * as Effects from 'redux-saga/effects'
import { AuthorizationActions } from '../../reducers/userAccount/actionNames'
import { isLicenseValid } from '../../reducers/userAccount/selectors/license'
import LogRocket from 'logrocket'

function* logRocketInit() {
  yield Effects.delay(3000)
  const user = yield Effects.select(state => state.userAccount.user)
  const premium = yield Effects.select(isLicenseValid)
  const environment = mapEnvToLogRocketEnv(process.env.REACT_APP_API_URL)

  if (user.debug_mode) {
    LogRocket.init('n7ybiv/bedbooking', {
      rootHostname: 'bed-booking.com',
      network: {
        requestSanitizer: request => {
          if (request.url.toLowerCase().indexOf('google') !== -1) return null
          if (request.url.toLowerCase().indexOf('static') !== -1) return null
          if (request.url.toLowerCase().indexOf('mixpanel') !== -1) return null
          if (request.url.toLowerCase().indexOf('chunk') !== -1) return null
          if (request.url.toLowerCase().indexOf('ingest') !== -1) return null
          if (request.url.toLowerCase().indexOf('youtube') !== -1) return null
          return request
        },
        responseSanitizer: response => {
          return response
        },
      },
    })
    LogRocket.identify(user.id, {
      email: user.email,
      premium: premium,
      environment: environment,
    })
  }
}

export default function*() {
  yield Effects.takeEvery(
    AuthorizationActions.AuthorizationGranted,
    logRocketInit,
  )
}

export const mapEnvToLogRocketEnv = (env: string) => {
  if (env.includes('rc')) {
    return 'rc'
  }
  if (env.includes('dev')) {
    return 'dev'
  }

  return 'prod'
}
